import React from 'react';

import Icon from 'presentation/icons';
import {translations} from 'presentation/translations-new';
import {TokenEnum} from 'presentation/constants';
import {useNavigate} from 'react-router-dom';
import {Token} from './styles';
import {useThemeStore} from 'presentation/store/useThemeStore';

const {token} = translations['pt-br'].privateFlow.services;

export function TokenButton() {
	const navigate = useNavigate();
	const theme = useThemeStore(state => state.theme);

	const handleNavigate = () => {
		navigate(TokenEnum.TOKEN);
	};

	return (
		<Token onClick={handleNavigate}>
			<Icon
				name="key-filled"
				size={18}
				fill={
					theme.name === 'hap'
						? theme.palette.common.white
						: theme.palette.other?.planColor
				}
			/>
			{token}
		</Token>
	);
}
